// This barrel file re-exports either the native or the web version of the Alert component based on the platform.
export { Alert } from "./Alert"
export { AlertContainer } from "./Alert.web"
